var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.547,
    height: 26.572,
    viewBox: "0 0 33.547 26.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "youtube-svgrepo-com",
    d: "M31.536,22.184a5.413,5.413,0,0,1-3.6,2.985,67.39,67.39,0,0,1-11.5.7h-.021a67.653,67.653,0,0,1-11.5-.7,5.422,5.422,0,0,1-3.606-2.987C1.255,22.057,0,19.024,0,12.936S1.255,3.814,1.309,3.688A5.416,5.416,0,0,1,4.915.7a67.411,67.411,0,0,1,11.5-.7A67.737,67.737,0,0,1,27.931.7a5.419,5.419,0,0,1,3.606,2.985c.053.127,1.311,3.162,1.311,9.249S31.591,22.057,31.536,22.184ZM29.659,4.56a3.418,3.418,0,0,0-2.1-1.738,67.436,67.436,0,0,0-11.122-.666,67.682,67.682,0,0,0-11.146.666,3.413,3.413,0,0,0-2.1,1.742c-.01.023-1.131,2.8-1.131,8.372s1.121,8.348,1.133,8.376a3.41,3.41,0,0,0,2.1,1.738,67.5,67.5,0,0,0,11.124.666h.021a67.473,67.473,0,0,0,11.123-.666,3.413,3.413,0,0,0,2.1-1.742c.01-.024,1.133-2.8,1.133-8.372S29.67,4.587,29.659,4.56ZM13.9,19.238a.982.982,0,0,1-1.043.031,1.087,1.087,0,0,1-.531-.943V7.546a1.085,1.085,0,0,1,.527-.941.983.983,0,0,1,1.04.024l8.232,5.343a1.107,1.107,0,0,1,.007,1.828Zm.48-9.758v6.894L19.644,12.9Z",
    transform: "translate(0.349 0.35)",
    fill: "#f8f4f1",
    stroke: "#5d0d19",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeFooter);
export default __webpack_public_path__ + "static/media/youtube_footer.fce5d824395bf5cb60829657cb791cf8.svg";
export { ForwardRef as ReactComponent };